import React from 'react';
import { Img } from 'react-image';
import { PositionStatus } from 'types';

interface Props {
	positionId?: string;
	positionStatus?: PositionStatus;
	invitedCandidates: number | '-';
	candidatesInPipeline: number | '-';
	completed?: boolean;
	handleViewRecommendations: () => void;
	assessmentCompletedCandidates: number | '-';
	hideRecommendations?: boolean;
	unSeenByRecruiter?: number;
	handleOverallToGraphView: () => void;
	handleSentInvite: () => void;
}

const TextFooter = (args: { text: string }) => {
	return (
		<div className="px-4 py-5 bg-[#FAFAFC] dark:bg-[#111E2C] flex items-center border-t border-[#E4E4EB] dark:border-0 rounded-b-[12px]">
			<div className="text-xs font-medium text-orange-500 dark:text-[#FDDD48]">{args.text}</div>
		</div>
	);
};

const HiringPostionCardFooter = ({
	// positionStatus,
	invitedCandidates,
	candidatesInPipeline,
	handleViewRecommendations,
	handleOverallToGraphView,
	handleSentInvite,
	unSeenByRecruiter,
	hideRecommendations = false,
	assessmentCompletedCandidates,
}: Props) => {
	// if (positionStatus === PositionStatus.CLOSED && !isPublished)
	// 	return <TextFooter text="This job posting was under review and has now been closed" />;
	// if (positionStatus === PositionStatus.CLOSED) return <TextFooter text="This job posting is closed" />;
	// if (!isPublished || (Number(recommendations) <= 2 && Number(inPipeLineUsers) === 0 && Number(connected) === 0))
	// 	return <TextFooter text="This job posting is under review" />;
	return (
		<div className="py-2 px-4 bg-[#FAFAFC] dark:bg-[#111E2C] flex items-center border-t rounded-b-[12px]">
			<div className="bg-[#FAFAFC] dark:bg-[#111E2C] flex items-center grow-2">
				<div className="flex gap-4">
					<button
						onClick={handleOverallToGraphView}
						className="rounded border border-light-0 bg-white flex p-1 px-2 items-center gap-2 sm:hidden"
					>
						<img src="/assets/recruiterDashboard/OverallAssessment.svg" alt="Overall Assessment" />
						<span className="text-[#7777E7] font-inter text-sm font-medium leading-5">Overall</span>
					</button>
					<button
						onClick={handleViewRecommendations}
						className="rounded border border-light-0 bg-white flex p-1 px-2 items-center gap-2"
					>
						<img src="/assets/recruiterDashboard/ListAssessment.svg" alt="Overall Assessment" />
						<span className="text-[#7777E7] font-inter text-sm font-medium leading-5">List</span>
						{unSeenByRecruiter == 0 ? null : (
							<span className="bg-[#fcbd30] dark:bg-[#fcbd30] text-black dark:text-black rounded-full text-xs font-medium leading-4 px-2">
								{unSeenByRecruiter} new
							</span>
						)}
					</button>
					<button
						onClick={handleSentInvite}
						className="rounded border border-light-0 bg-white flex p-1 px-2 items-center gap-2"
					>
						<img src="/assets/recruiterDashboard/InviteAssessment.svg" alt="Overall Assessment" />
						<span className="text-[#7777E7] font-inter text-sm font-medium leading-5">Invite</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default HiringPostionCardFooter;
